module.exports = __webpack_public_path__ + "img/image_poi-887dd55d.png";